module.exports = __webpack_public_path__ + "static/media/login_map.6a1e4c36.svg";